module.exports = "/images/warning.png?990e0ec91211eea89c96cf4bcac0ab4b";